import {PostAttendanceTrackerRegistryRecord} from '../backend/requests/post-attendance-tracker-registry-record';
import {PostAttendanceTrackerRegistrySessionReplace} from '../backend/requests/post-attendance-tracker-registry-session-replace';
import {
  AttendanceTrackerRegistryRecordRegistration,
  AttendanceTrackerRegistrySessionDetails,
  AttendanceTrackerRegistrySessions,
  AttendanceTrackerRegistryUser,
} from '../backend/responses/attendance-tracker-registry';
import {BackendApiManager} from '../managers/backend-api';

export class EntityAttendanceTrackerRegistryRepository {
  // Singleton Instance
  private static _instance: EntityAttendanceTrackerRegistryRepository;

  static get instance(): EntityAttendanceTrackerRegistryRepository {
    if (!this._instance) {
      this._instance = new EntityAttendanceTrackerRegistryRepository();
    }
    return this._instance;
  }

  // Get the work sessions of the professionals of the entity (or of one of them) with the entry or the exit in the
  // interval, and the open sessions
  public async getSessions(
    entityId: string,
    startDate: string,
    endDate: string,
    userId?: string
  ): Promise<AttendanceTrackerRegistrySessions> {
    const response = await BackendApiManager.instance.get<AttendanceTrackerRegistrySessions>(
      `/entities/${entityId}/attendance-tracker/registry/sessions?startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}${userId ? `&userId=${userId}` : ''}`
    );

    return response.data;
  }

  // Get the active professionals that must or can track attendance, the ones records can be registered for
  public async getProfessionals(entityId: string): Promise<AttendanceTrackerRegistryUser[]> {
    const response = await BackendApiManager.instance.get<AttendanceTrackerRegistryUser[]>(
      `/entities/${entityId}/attendance-tracker/registry/professionals`
    );

    return response.data;
  }

  // Register, on behalf of a professional, an entry, an exit, or an entry and its exit
  public async registerRecords(
    entityId: string,
    body: PostAttendanceTrackerRegistryRecord
  ): Promise<AttendanceTrackerRegistryRecordRegistration> {
    const response =
      await BackendApiManager.instance.post<AttendanceTrackerRegistryRecordRegistration>(
        `/entities/${entityId}/attendance-tracker/registry/records`,
        body
      );

    return response.data;
  }

  // Void a work session (its entry and its exit): it is kept, but it does not count anymore
  public async voidSession(
    entityId: string,
    sessionId: string,
    reason: string
  ): Promise<AttendanceTrackerRegistrySessionDetails> {
    const response = await BackendApiManager.instance.post<AttendanceTrackerRegistrySessionDetails>(
      `/entities/${entityId}/attendance-tracker/registry/sessions/${sessionId}/void`,
      {reason}
    );

    return response.data;
  }

  // Correct a work session: it is voided and the records with the right data are registered in its place
  public async replaceSession(
    entityId: string,
    sessionId: string,
    body: PostAttendanceTrackerRegistrySessionReplace
  ): Promise<AttendanceTrackerRegistryRecordRegistration> {
    const response =
      await BackendApiManager.instance.post<AttendanceTrackerRegistryRecordRegistration>(
        `/entities/${entityId}/attendance-tracker/registry/sessions/${sessionId}/replace`,
        body
      );

    return response.data;
  }
}
